export default __webpack_public_path__ + "static/media/tented.1fc8cacf.png";